export const enum PageTemplatesEnum {
  Questionnaire = 'questionnaire',
}

export namespace PageTemplatesMetadata {
  export type PageTemplatesMetadataCommonType = Record<string, any>;
  export type Questionnaire<T = PageTemplatesMetadataCommonType> = T & {
    databaseUuid: string;
  }
}

export type PageTemplatesModel<T = PageTemplatesMetadata.PageTemplatesMetadataCommonType> = {
  id: string;
  appId: string;
  name: string;
  type: PageTemplatesEnum;
  metadata: T;
  createdAt: string; // Date
  updatedAt: string; // Date
  deletedAt?: string; // Date
}
